import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TreeNodeSelectEvent } from 'primeng/tree';
import { CustomTreeNode } from 'src/app/models/custom-tree-node';
import { SelectableTreeNode } from 'src/app/models/selectable-tree-node';

@Component({
  selector: 'app-search-tree',
  templateUrl: './search-tree.component.html',
  styleUrls: ['./search-tree.component.scss']
})
export class SearchTreeComponent{

  @Input() tree!: CustomTreeNode;
  @Output() onToggle = new EventEmitter<CustomTreeNode>();
  @Output() onUnselect = new EventEmitter<CustomTreeNode>();
  @Input() currentLanguage!: string;

  filteredTree: CustomTreeNode<any>[] | null | undefined;
  previousFilterValue: string | undefined;
  expandedKeys: any;

  handleSelection(selectEvent: TreeNodeSelectEvent) {
        const event = selectEvent.originalEvent;
        const node = selectEvent.node as SelectableTreeNode;
    
        if (event instanceof KeyboardEvent) {
          switch (event.key) {
            case ' ':
            case 'Enter':
              event.preventDefault();
              this.handleToggle(node);
              if (event.key === 'Enter' && node.children?.length) {
                this.toggleExpand(node);
              }
              break;
            case 'ArrowLeft':
              event.preventDefault();
              if (node.children?.length && !node.expanded) {
                this.toggleExpand(node);
              }
              break;
            case 'ArrowRight':
              event.preventDefault();
              if (node.children?.length && node.expanded) {
                this.toggleExpand(node);
              }
              break;
          }
        } else {
          this.handleToggle(node);
        }
      }

  handleToggle(node: CustomTreeNode) {
    this.onToggle.emit(node);
  }

  toggleExpand(node: SelectableTreeNode) {
    node.expanded = !node.expanded;
  }
}